import $ from "jquery";

$(function() {

  $('[data-flash-modal]').each(function() {
    $(this).modal('show');
  });

});